module.exports = __webpack_public_path__ + "static/img/appbanner.dbaa61d0.jpg";